export const sagradacena = {
	nombre: "Sagrada Cena",
	dia: "Domingo de Ramos",
	nombrecompleto:
		"Hermandad Sacramental y de Penitencia y Cofradía de Nazarenos de la Pura y Limpia Madre de Dios, Nuestro Padre Jesús del Milagro en la Sagrada Cena y María Santísima Reina de Todos los Santos",
	sede: "Iglesia Conventual de Santo Domingo",
	pasos: 1,
	distancia: [963, 1700],
	penitentes: 130,
	cargadores: 74,
	web: "http://www.diariodecadiz.es/semana_santa/Cena_0_1229277793.html",
	ida: [
		{ lng: -6.2901691, lat: 36.5288499 },
		{ lng: -6.2903434, lat: 36.5289706 },
		{ lng: -6.2904641, lat: 36.528754 },
		{ lng: -6.2912795, lat: 36.5290525 },
		{ lng: -6.2914297, lat: 36.5291743 },
		{ lng: -6.2916389, lat: 36.529226 },
		{ lng: -6.2924798, lat: 36.5295353 },
		{ lng: -6.2927829, lat: 36.5297583 },
		{ lng: -6.2926327, lat: 36.5298661 },
		{ lng: -6.2919379, lat: 36.5304448 },
		{ lng: -6.2926487, lat: 36.5312444 },
		{ lng: -6.2929152, lat: 36.531075 },
		{ lng: -6.2922006, lat: 36.5302712 },
		{ lng: -6.2928142, lat: 36.5297751 },
		{ lng: -6.2930785, lat: 36.5298029 },
		{ lng: -6.2933538, lat: 36.5297235 },
		{ lng: -6.2941386, lat: 36.5296687 },
		{ lng: -6.2945182, lat: 36.5296332 },
		{ lng: -6.2951237, lat: 36.5294851 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956917, lat: 36.5291225 },
		{ lng: -6.295516, lat: 36.5295665 },
		{ lng: -6.2954088, lat: 36.5297605 },
		{ lng: -6.295673, lat: 36.5299545 },
		{ lng: -6.2952881, lat: 36.5303424 },
		{ lng: -6.2950829, lat: 36.530697 },
		{ lng: -6.2950252, lat: 36.5308295 },
		{ lng: -6.2949206, lat: 36.5308392 },
		{ lng: -6.2949219, lat: 36.5314632 },
		{ lng: -6.2952264, lat: 36.5315106 },
		{ lng: -6.2964723, lat: 36.5317714 },
		{ lng: -6.2964146, lat: 36.5318629 },
		{ lng: -6.2965769, lat: 36.5321151 },
		{ lng: -6.2967847, lat: 36.5325418 },
		{ lng: -6.2964199, lat: 36.5329341 },
		{ lng: -6.2962671, lat: 36.533239 },
		{ lng: -6.296314, lat: 36.5332757 },
		{ lng: -6.2962671, lat: 36.5339309 },
		{ lng: -6.2961403, lat: 36.5339486 },
		{ lng: -6.2960055, lat: 36.5339643 },
		{ lng: -6.2956488, lat: 36.5335493 },
		{ lng: -6.2944995, lat: 36.5322832 },
		{ lng: -6.2940663, lat: 36.5324125 },
		{ lng: -6.2936962, lat: 36.5319448 },
		{ lng: -6.2932375, lat: 36.53144 },
		{ lng: -6.2932268, lat: 36.5314168 },
		{ lng: -6.2927219, lat: 36.5308182 },
		{ lng: -6.2924493, lat: 36.5305253 },
		{ lng: -6.2923143, lat: 36.5303789 },
		{ lng: -6.2922465, lat: 36.5302907 },
		{ lng: -6.2928357, lat: 36.5297945 },
		{ lng: -6.2924784, lat: 36.5295137 },
		{ lng: -6.2916362, lat: 36.5292141 },
		{ lng: -6.2914351, lat: 36.5291613 },
		{ lng: -6.2912849, lat: 36.5290396 },
		{ lng: -6.290452, lat: 36.5287357 },
		{ lng: -6.2903421, lat: 36.5289501 },
		{ lng: -6.2901784, lat: 36.5288423 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-25T17:30",
			latlng: [36.5288, -6.29012]
		},
		{
			name: "Nueva",
			hora: "2018-03-25T19:00",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-25T20:00",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-25T21:00",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-25T21:25",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-25T21:35",
			latlng: [36.53266, -6.29667]
		}
	],
	itinerario: [
		[
			"Compás de Santo Domingo",
			"Sopranis",
			"Plaza San Juan de Dios",
			"Avda. 4 de diciembre de 1977",
			"Cristóbal Colón",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pío XII",
			"Estación de Penitencia en la S.I.C"
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego José de Cádiz",
			"Rosario",
			"Plaza San Agustín",
			"San Francisco (dcha.)",
			"Nueva",
			"Plaza San Juan de Dios",
			"Sopranis",
			"Compás de Santo Domingo"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/sagradacena.js